import { MapDataSource } from "../models/MapDataSource";

export async function fetchUpdateDataYear(source: MapDataSource): Promise<number> {
  return source.updateDate ? +`1${source.updateDate.getFullYear()}0101` : 0;
};